<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('messages')}}</span>
          </div>
          <div class="main-header-right" :class="{'de22':isDe||isFr,'cz22':isCz}">
            <p  @click="back">{{$t('home')}}</p>
            <img src="../../assets/back.png">
          </div>
        </div>
        <hr class="small-hr">
        <div  v-for="(item,index) in messages">
          <div class="note1"  :class="{'notRead':(item[3]==='N')}" :id="index" >
            <img class="portrait" :src=item[4]>
            <div class="text">
              <p>{{item[1]}}</p>
              <p class="time">{{item[2]}}</p>
            </div>
            <div class="operate" @click="read(index)" v-show="(item[3]==='N')">
              <span>{{$t('Read')}}</span>
            </div>
          </div>
          <hr class="small-hr">
        </div>
        <p v-show="noMes" class="noMes">{{$t('noMes')}}</p>
      </el-card>
      <div class="Hcp-footer">
        <span>
<!--          <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
                        <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

          {{$t('copyright')}} <br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default{
    data(){
      return{
        isRead:true,open:false,tip:false,usterType:'',uid:0,noMes:false,isZh:false,isDe:false,isFr:false,isZh1:false,
        messages:[],isCz:false,
        accept:this.$t('acceptTip'),
        cancel:this.$t('cancelTip'),
        reject:this.$t('rejectTip'),
        isEU:true,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },
    computed:{
      portrait(){
        return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('uid'))+'/portrait'
      }
    },
    methods:{
      back(){
        this.usterType = sessionStorage.getItem('userType');
        if(this.usterType==='D'){
          this.$router.push('/PatientList');
        }else if(this.usterType==='M'){
          this.$router.push('/carerConnection');
        }
      },
      read(index){
          let obj = document.getElementById(index);
          let mid = this.messages[index][0];
          obj.className = 'note1';
         this.$http.post('api/v2.0/messages/'+mid+'/read',{}).then(function(res){
            let err =res.body.error;
            if(err===0){
              auth.getMessages(this,this.uid);
              auth.getUnread(this);
            }
          })
      },
      Open(){
        this.tip = !this.tip
      },
    },
    mounted(){
      this.uid = parseInt(sessionStorage.getItem('uid'));
      let lang = sessionStorage.getItem('language');
      this.isZh = (lang==='zh'||lang==='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isZh1= (lang==='zh')?true:false;
      this.isCz= (lang==='cz')?true:false;
      let countryIndex=localStorage.getItem('index');
      //console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      auth.getMessages(this,this.uid);

      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    },
  }
</script>
<style scoped>
  .newPatient-container{
    min-height:889px;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  @media screen and (min-height: 950px){
    .container{
      min-height:900px;
    }
  }
  .main-container{
    width:97%;
    margin:0 auto;
    min-height: 819px;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    padding-bottom: 20px;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:140px;
    height:20px;
    line-height: 20px;
    margin-right: 3%;
  }
  .de22{
    width:90px;
  }
  .cz22{
    width:80px;
  }
  .main-header-right img{
    *display: block;
    margin-top: 5px;
    margin-right:5px;
    float: right;
  }
  .main-header-right p{
    float:right;
    color:#0082d2;
    margin-top: 2px;
    cursor: pointer;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto;
    border:none;
  }
  .spe-hr{
    width: 94%;
  }
  .note1{
    width:98%;
    height:70px;
    padding-top: 30px;
    margin:5px auto;
  }
  .portrait{
    border-radius:100px;
    width:51px;
    height:51px;
    margin-top: -5px;
    float: left;
    margin-left: 1%;
  }
  .note1 .text{
    float: left;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
    margin-left: 20px;
    margin-bottom: 20px;
    width: 80%;
    min-width: 450px;
  }
  .note1 .time{
    color:#6e6e6e;
    margin-top: 8px;
  }
  .note1 .operate{
    float: right;
    margin-right: 2%;
    margin-top: 5px;
  }
  .operate span{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#0082d2;
    letter-spacing:-0.43px;
    margin-right: 25px;
    cursor: pointer;
  }
  .operate img{
    float: right;
    margin-top: 5px;
    cursor: pointer;
  }
  .notRead{
    background-color:#edf2fa;
    cursor: pointer;
  }
  .tip{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    margin-left: 8%;
    margin-top: 20px;
    margin-bottom: 20px;
    background:#f9fcff;
  }
  .transform{
    transform: rotate(180deg);
  }
  .noMes{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#ff3c3c;
    margin-top: 20px;
    margin-left: 20px;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }
</style>



// WEBPACK FOOTER //
// messages.vue?5d91f3bc